export function safeUriDecode(uri: string): string {
    try {
        return decodeURIComponent(uri);
    } catch (err) {
        return '';
    }
}
